import { movimentsTypes } from "../../../../pages/financeiro/constants";
import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const path = `${process.env.REACT_APP_URL_API_REPORTS}/exerciseresult`;
const pathV3 = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant`;

const documentsHubPath = `${process.env.REACT_APP_URL_API_DOC_HUB}/reports`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findRE(filterProps) {
  const url = new URL(path);
  url.searchParams.append("moviment", movimentsTypes.Todos);
  url.searchParams.append("useFinanceCategories", true);
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value) {
      url.searchParams.append(key, value);
    }
  });

  return search(url.toString(), "GET", headers);
}

export async function printREtoPDF({
  title,
  type,
  group,
  orientation,
  groupByFinanceCategories,
  companyName,
  companyFantasy,
  headerLogo,
  login,
  filter,
  movement,
  searchPeriod,
  total,
}) {
  const url = `${documentsHubPath}/result-exercise/generate`;

  return search(`${url}`, "POST", headers, {
    title,
    type,
    group,
    orientation,
    groupByFinanceCategories,
    companyName,
    companyFantasy,
    headerLogo,
    login,
    filter,
    movement,
    searchPeriod,
    total,
  });
}

export const getFinancialNestedCategories = async (companyDocument) => {
  const url = `${pathV3}/empresa/${companyDocument}/financeiro/centrosnegocios/categorias`;
  return search(url, "GET", headers);
};
